const numberSlashNumber = /\d+\/\d+/;

export { numberSlashNumber as n };

